import React from "react";
import "./services.css";
import WebDesign from "../../assets/webDesing.png";
import SocialMedia from "../../assets/socialMedia.png";
import DigitalMarketing from "../../assets/digitalMarketing.png";
const index = () => {
  return (
    <div className="servicesContainer">
      <h2 className="servicesHeading">Take A Look</h2>
      <div className="titleUnderline"></div>
      <h1 className="servicesHeading2">My Services</h1>
      <div className="servicesItems">
        <div className="servicesItem1">
          <img src={WebDesign} alt="web design" className="servicesIcon"/>
          <h2>Web Design</h2>
          <div className="servicesUnderline"></div>
          <p>
            I provide Best and Quality website which will have Great User
            Interface and of easy navigation.
          </p>
        </div>
        <div className="servicesItem2">
          <img src={SocialMedia} alt="Social Media" className="servicesIcon"/>
          <h2>Graphic Design</h2>
          <div className="servicesUnderline"></div>
          <p>
            Visual is the best way to attract Customers. I deal with each and
            every aspect of Graphics design.
          </p>
        </div>
        <div className="servicesItem3">
          <img src={DigitalMarketing} alt="Digital Marketing" className="servicesIcon"/>
          <h2>Marketing</h2>
          <div className="servicesUnderline"></div>
          <p>
            Marketing is most essential for all Business. I follow the best and
            unique stragy from Digital Marketing
          </p>
        </div>
      </div>
    </div>
  );
};

export default index;
